export default {
  // trade in
  tradeIn: {
    value: null,
    amountOwed: null,
    condition: null
  },
  // credit bracket
  creditType: 'b',
  // down payment
  downPayment: null,
  downPaymentPercent: 0.2,
  // loan terms / defaults are from VDP calculator but should probably change
  leaseMileageRange: 12000,
  leaseTerm: 36,
  loanTerm: 60,
  interestRate: {
    isFallback: true,
    custom: null,
    new: 6.0,
    used: 7.05
  },
  // affordability / max budget
  budget: null,
  interactions: {
    // display preferences
    paymentEmphasis: null
  },
  paymentOption: 'finance',
  zip: null
};